export enum DialogEventStatusMenuEntryKind {
  Action = 'action',
  Group = 'group',
}
